<template>
  <div>
	<h2>Show Details of Timesheet</h2>
  </div>
</template>

<script>

import envConfig from './env_config.js'
import * as easing from 'eases/bounce-in'
import axios from 'axios'
const http = axios.create({
  withCredentials: true,
  crossdomain: true
})
export default {
  name: 'Timesheet',
  props: {
  },
  data () {
    return {
      easing,
      notesmsg:'',
      notestextarea: notestextareaClass,
      opennotestextarea: false,
      pagetitle:'',
      pageloading:true,
      floatmessage: '',
      subtitle: '',
      seen: [],
      pageref:''
    }
  },
  methods: {
    axiosCall:function(myurl){

      this.pageloading = true;
      var self = this;

      http.get(myurl, { withCredentials: true, crossdomain: true }).then(ret => {
		
      }).catch(function () {
        self.floatmessage = 'Having Trouble Connecting';
      })
    }
  },
  mounted() {
    this.pageref = this.$route.path;
    this.getSeenList();
  },
  created: function () {
    this.axiosCall(myurl);


  },
        
  beforeCreate: function() {
      document.body.className = this.$route.fullPath.substr(1);
  }
}

</script>
<style>
</style>





